import { Control, Path, useController } from 'react-hook-form';

import { FormValues } from '../types';

export interface UseCourseList<T extends FormValues> {
  control: Control<T>;
  name: Path<T>;
}

const useCourseList = <T extends FormValues>({ control, name }: UseCourseList<T>) => {
  const { field } = useController({ control, name });
  const { value } = field;

  const selectedCourseId: MongoId | null = value ? (value as MongoId) : null;

  return { selectedCourseId };
};

export default useCourseList;
